import newsApi from "@/api/newsApi";
import { all_news_lan, idVlsDomain_in } from "@/components/NewsMain/Default/hooks/useNewsList";
import { getSearchParam } from "@/utils";
import { isShowNews1 } from "@/utils/isShowNews1";

const lan = getSearchParam("lan") || "";
const { subdomain } = useSubdomain();
const recListState = atom({
  loadingRec: false,
  isEmptyRec: false,
  errMsgRec: "",
  recList: [],
  queryParams: {
    lan: isShowNews1().validMain
      ? all_news_lan[lan]
      : isShowNews1().isIdVls
        ? idVlsDomain_in[`${subdomain}.comfortweather.com`]
        : "EN-IN",
    newsId: "",
  },
});

const useRecListCtrl = () => {
  const [getRecList, setRecList] = useAtom(recListState);
  return {
    loadingRec: getRecList.loadingRec,
    isEmptyRec: getRecList.isEmptyRec,
    errMsgRec: getRecList.errMsgRec,
    recList: getRecList.recList,
    queryParams: getRecList.queryParams,
    setRecList,
  };
};

const useRecListHook = () => {
  const { queryParams, setRecList } = useRecListCtrl();
  async function loadRecList() {
    try {
      const res = await newsApi.queryRecommendList(queryParams);
      if (!isEmptyType(res.data.row)) {
        setRecList(prev => ({
          ...prev,
          loadingRec: false,
          isEmptyRec: false,
          errMsgRec: "",
          recList: res.data.row || [],
        }));
      } else {
        setRecList(prev => ({
          ...prev,
          loadingRec: false,
          isEmptyRec: true,
          errMsgRec: "",
        }));
      }
      return res;
    } catch (error) {
      console.error("Failed to fetch news-rec:", error);
      setRecList(prev => ({
        ...prev,
        loadingRec: false,
        isEmptyRec: false,
        errMsgRec: error instanceof Error ? error.message : "未知错误",
      }));
    }
  }
  return {
    loadRecList,
  };
};

export { useRecListCtrl, useRecListHook };
